import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    timeout: { type: Number, default: 3000 }
  }

  connect() {
    this.timeout = window.setTimeout(() => this.hideFlash(), this.timeoutValue)
  }

  disconnect() {
    window.clearTimeout(this.timeout)
    window.clearTimeout(this.removeTimeout)
  }

  close() {
    window.clearTimeout(this.timeout)
    this.hideFlash()
  }

  hideFlash() {
    if (this.element.classList.contains('flash--leaving')) return

    this.element.classList.add('flash--leaving')
    this.removeTimeout = window.setTimeout(() => {
      this.element.hidden = true
    }, 150)
  }
}
